import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroPage = _resolveComponent("HeroPage")!

  return (_openBlock(), _createBlock(_component_HeroPage, {
    line1: _ctx.line1,
    line1MaskHeight: _ctx.line1MaskHeight,
    line1Indent: _ctx.line1Indent,
    line2: _ctx.line2,
    line2MaskHeight: _ctx.line2MaskHeight,
    line2Indent: _ctx.line2Indent,
    line3: _ctx.line3,
    line3MaskHeight: _ctx.line3MaskHeight,
    line3Indent: _ctx.line3Indent,
    line4: _ctx.line4,
    line4MaskHeight: _ctx.line4MaskHeight,
    line4Indent: _ctx.line4Indent
  }, null, 8, ["line1", "line1MaskHeight", "line1Indent", "line2", "line2MaskHeight", "line2Indent", "line3", "line3MaskHeight", "line3Indent", "line4", "line4MaskHeight", "line4Indent"]))
}